<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<!--판매일자-->
				<el-col :span="3">
					<sf-group-wrapper :label="getMessage_('QWCC001648')">
						<el-date-picker
							v-model="searchParams.searchDate"
							@change="changeSearchDate"
							type="year"
							align="right"
							format="yyyy"
							style="height: 38px"
						/>
					</sf-group-wrapper>
				</el-col>
				<!-- 부품유형 -->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC000059')"
						paramKey="partType"
						:options="partTypeList"
						:propData="searchParams.partType"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				<!--차량구분-->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001015')"
						paramKey="carScn"
						:options="carScnList"
						:propData="searchParams.carScn"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				<!--승상구분-->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001017')"
						paramKey="pacScn"
						:options="pacScnList"
						:propData="searchParams.pacScn"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				<!--생산법인-->
				<!-- <el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001546')"
						paramKey="customPrCor"
						:options="customPrCorList"
						:propData="searchParams.customPrCor"
						@commChange="setSearchParam"
					></select-combo>
				</el-col> -->
				<!--생산공장-->
				<!-- <el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001540')"
						paramKey="plntCd"
						:options="plntCdList"
						:propData="searchParams.plntCd"
						@commChange="setSearchParam"
					></select-combo>
				</el-col> -->
				<!--
			</el-row>
			<el-row :gutter="20">
				-->
				<!--연료전지사양-->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001021')"
						paramKey="flclSpc"
						:options="flclSpcList"
						:propData="searchParams.flclSpc"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				<!--판매국가-->
				<!-- <el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001542')"
						paramKey="saleNat"
						:options="saleNatList"
						:propData="searchParams.saleNat"
						@commChange="setSearchParam"
					></select-combo>
				</el-col> -->
				<!--판매지역-->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001019')"
						paramKey="occuRegn"
						:options="occuRegnList"
						:propData="searchParams.occuRegn"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>

				<!--조회구분-->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC002049')"
						paramKey="srchScn"
						:options="srchScnList"
						:propData="searchParams.srchScn"
						@commChange="setSearchParam"
						:showAll="false"
					></select-combo>
				</el-col>
				<!--차량유형-->
				<el-col :span="3">
					<search-input
						:label="getMessage_('QWCC001016')"
						paramKey="carTypeNm"
						:propData="searchParams.carTypeNm"
						@commInput="setSearchParam"
					/>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/clma/PcIdxNum12M/store/helpers';
import SelectCombo from '@qms/Components/SelectCombo';
import SearchInput from '@qms/Components/SearchInput';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {};
	},
	components: { SelectCombo, SearchInput },
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		setSearchParam(param) {
			this.setSearchParam_(param);
		},
		searchList() {
			if (this.searchParams.searchDate === null) {
				// let today = this.$moment('2022-01-01').format('YYYYMMDD');
				let today = this.$moment().format('YYYY') + '-01-01';
				let thisYear = today.substring(0, 4);
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('SWCC000008'),
					message: this.getMessage_('QWCC001622')
				}); //판매일자는 필수 검색 값입니다.
				this.setSearchParam_({ key: 'searchDate', value: thisYear });
			} else {
				this.$sf_toggleLoading(true);
				//재조회시 필수
				this.setState_({ key: 'isLoading', value: false });
				this.getCarSalesList_({})
					.catch(error => {
						this.$sf_toast({
							type: 'error',
							message: error.message
						});
						Promise.reject(error);
					})
					.finally(() => {
						this.$sf_toggleLoading(false);
					});
			}
		},
		// changeSearchDate(data) {
		// 	let today = this.$moment('2022-01-01').format('YYYYMMDD');
		// 	if (data === null || data === '') {
		// 		let thisYear = today.substring(0, 4);
		// 		this.$sf_showMessage({
		// 			icon: 'error',
		// 			title: this.getMessage_('SWCC000008'),
		// 			message: this.getMessage_('QWCC001622')
		// 		}); //판매일자는 필수 검색 값입니다.
		// 		this.setSearchParam_({ key: 'searchDate', value: thisYear });
		// 	} else {
		// 		let dataArr = data.toString().split(' ');
		// 		let searchYear = dataArr[3];

		// 		this.setSearchParam_({ key: 'searchDate', value: searchYear });
		// 		this.searchList();
		// 	}
		// },
		changeSearchDate(data) {
			// let today = this.$moment('2022-01-01').format('YYYYMMDD');
			let today = this.$moment().format('YYYY') + '-01-01';
			if (data === null || data === '') {
				let thisYear = today.substring(0, 4);
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('SWCC000008'),
					message: this.getMessage_('QWCC001622')
				}); //판매일자는 필수 검색 값입니다.
				this.setSearchParam_({ key: 'searchDate', value: thisYear });
			} else {
				const changeDate = this.$moment(data).format('YYYYMMDD');
				let diffMonth = this.$moment(changeDate).diff(this.$moment(today), 'days');
				if (diffMonth > 0) {
					this.$sf_showMessage({
						icon: 'error',
						title: this.getMessage_('SWCC000008'),
						message: this.getMessage_('QWCC001550')
					}); //기준년도는 올해까지 선택 가능합니다.
					let thisYear = today.substring(0, 4);
					this.setSearchParam_({ key: 'searchDate', value: thisYear });
				} else {
					let dataArr = data.toString().split(' ');
					let searchYear = dataArr[3];

					this.setSearchParam_({ key: 'searchDate', value: searchYear });
					this.searchList();
				}
			}
		},
		onCheck(key, value) {
			if (value) this.setSearchParam_({ key, value: 'Y' });
			else this.setSearchParam_({ key, value: 'N' });
		}
	},
	async created() {
		try {
			await this.postSearchSelectList_();
			// await this.getCommCodeDetails_({ key: 'customPrCorList', codeType: '' }); //생산법인;

			await this.searchList();
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			return error;
		}
	}
};
</script>

<style></style>
